/* ==========================================================================
   ATELIER WISHLIST controller
   SWishlist stays the DATA LAYER. We read window.SWishlist.getList(), render our
   own Atelier .pc cards (Section Rendering API per handle), and route remove/count
   back through SWishlist so hearts + the header badge stay in sync.
   getList() -> async -> products array; items: { handle, id, variantId, wishlistId,
   addedAt|addedDate }. removeFromWishlist(handle) resolves the wishlist entry from
   the product. See memory: atelier-wishlist-progress.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('atelier-wishlist');
  if (!root) return;

  var grid = root.querySelector('#awGrid');
  var toastEl = document.getElementById('awToast');
  var toastMsg = document.getElementById('awToastMsg');
  var items = [];          // normalised getList items, in display order
  var activeFin = null;
  var currentSort = 'newest';

  /* ---------- helpers ---------- */
  function toast(msg) {
    if (!toastEl) return;
    toastMsg.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1900);
  }
  function finLabel(slug) {
    return slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  function relTime(iso) {
    var t = Date.parse(iso); if (!t) return '';
    var d = Math.floor((Date.now() - t) / 86400000);
    if (d <= 0) return 'today';
    if (d === 1) return 'yesterday';
    if (d < 7) return d + ' days ago';
    if (d < 14) return 'a week ago';
    if (d < 31) return Math.floor(d / 7) + ' weeks ago';
    if (d < 61) return 'a month ago';
    return Math.floor(d / 30) + ' months ago';
  }
  function cardPrice(card) {
    var el = card.querySelector('.pc-pr .now');
    if (!el) return 0;
    var n = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  /* ---------- SWishlist readiness ---------- */
  function whenReady(cb) {
    if (window.SWishlist && typeof window.SWishlist.getList === 'function') return cb();
    document.addEventListener('SWishlistReady', function () { cb(); }, { once: true });
    var tries = 0;
    var iv = setInterval(function () {
      if (window.SWishlist && typeof window.SWishlist.getList === 'function') { clearInterval(iv); cb(); }
      else if (++tries > 40) { clearInterval(iv); cb(); }   // ~6s guard
    }, 150);
  }

  function normalise(it) {
    return {
      handle: it.handle || it.productHandle || it.Handle || '',
      id: it.id || it.productId || null,
      variantId: it.variantId || it.VariantId || null,
      wishlistId: it.wishlistId || it.WishlistId || null,
      addedAt: it.addedDate || it.addedAt || null
    };
  }
  function getList() {
    try {
      return Promise.resolve(window.SWishlist.getList()).then(function (res) {
        var arr = Array.isArray(res) ? res : (res && Array.isArray(res.products) ? res.products : []);
        return arr.map(normalise).filter(function (i) { return i.handle; });
      });
    } catch (e) { return Promise.resolve([]); }
  }

  /* ---------- card fetch + decorate ---------- */
  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=atelier-wishlist-card')
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }
  function buildCard(html, it) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var card = tmp.querySelector('.pc');
    if (!card) return null;
    var meta = tmp.querySelector('.aw-cm');
    card.dataset.handle = it.handle;
    card.dataset.finish = (meta && meta.dataset.finish) || 'other';
    card.dataset.finishName = (meta && meta.dataset.finishName) || '';
    card.dataset.added = it.addedAt ? (Date.parse(it.addedAt) || 0) : 0;

    // finish: a wishlist shows the finish you CHOSE, named - not the full shop-the-swatches row.
    // Drop the sibling swatch row; put a single selected swatch + finish name in its place.
    var oldFins = card.querySelector('.pc-fins');
    if (oldFins) oldFins.remove();
    if (card.dataset.finish && card.dataset.finish !== 'other' && card.dataset.finishName) {
      var fsel = document.createElement('div');
      fsel.className = 'pc-finsel';
      var fsw = document.createElement('span'); fsw.className = 'pc-finsel-sw ac-sw--' + card.dataset.finish;
      var fnm = document.createElement('span'); fnm.className = 'pc-finsel-nm'; fnm.textContent = card.dataset.finishName;
      fsel.appendChild(fsw); fsel.appendChild(fnm);
      var prc = card.querySelector('.pc-pr');
      if (prc && prc.parentNode) prc.parentNode.insertBefore(fsel, prc.nextSibling);
    }

    // remove-x on the image
    var im = card.querySelector('.pc-im');
    if (im) {
      var rm = document.createElement('button');
      rm.className = 'pc-rm'; rm.type = 'button'; rm.setAttribute('aria-label', 'Remove from wishlist');
      rm.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg>';
      rm.addEventListener('click', function (e) { e.preventDefault(); removeItem(card, it); });
      im.appendChild(rm);
    }
    // saved-date
    var bd = card.querySelector('.pc-bd');
    var act = card.querySelector('.pc-act');
    if (bd && act && it.addedAt) {
      var s = document.createElement('div');
      s.className = 'pc-saved';
      s.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.8-9.5-9.1C.9 8.2 3 4.5 6.7 4.5c2.2 0 3.9 1.2 5.3 3 1.4-1.8 3.1-3 5.3-3 3.7 0 5.8 3.7 4.2 7.4C19.5 16.2 12 21 12 21z"/></svg>Saved ' + relTime(it.addedAt);
      bd.insertBefore(s, act);
    }
    // +Project (INTERIM: routes to the PDP where the real Add-to-Project panel lives;
    // wiring that panel inline is the planned fast-follow - see memory)
    if (act) {
      var pj = document.createElement('button');
      pj.className = 'pc-proj'; pj.type = 'button'; pj.setAttribute('aria-label', 'Add to Project Studio');
      pj.setAttribute('data-apg-add-to-project', '');       // opens the shared PDP Add-to-Project panel (atelier-project-add.js delegated listener)
      pj.setAttribute('data-product-handle', it.handle);
      pj.innerHTML = '<svg viewBox="0 0 24 24"><path d="M3 7h7l2 2h9v9a2 2 0 0 1-2 2H3z"/><path d="M12 13v4M10 15h4"/></svg>';
      act.appendChild(pj);
    }
    return card;
  }

  /* ---------- render ---------- */
  function render() {
    return getList().then(function (list) {
      items = list;
      if (!items.length) { root.dataset.wlState = 'empty'; setCount(0); return; }
      root.dataset.wlState = 'loading';
      return Promise.all(items.map(function (i) { return fetchCard(i.handle); })).then(function (htmls) {
        grid.innerHTML = '';
        items.forEach(function (it, idx) {
          if (!htmls[idx]) return;
          var card = buildCard(htmls[idx], it);
          if (card) grid.appendChild(card);
        });
        root.dataset.wlState = 'ready';
        setCount(items.length);
        buildFinishSummary();
        buildProjStack();
        applySort(currentSort);
        applyFilter();
      });
    });
  }

  function setCount(n) {
    var c = document.getElementById('awCount'); if (c) c.textContent = n;
  }

  /* ---------- finish coordination summary ---------- */
  function buildFinishSummary() {
    var cards = grid.querySelectorAll('.pc');
    var counts = {};
    cards.forEach(function (c) {
      var f = c.dataset.finish;
      if (!f || f === 'other') return;
      counts[f] = (counts[f] || 0) + 1;
    });
    var fins = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    var chips = document.getElementById('awFinChips');
    var read = document.getElementById('awFinRead');
    chips.innerHTML = fins.map(function (f) {
      return '<button class="aw-fin-chip" type="button" data-fin="' + f + '">' +
        '<span class="aw-fin-sw ac-sw--' + f + '"></span>' +
        '<b>' + finLabel(f) + '</b><span class="n">' + counts[f] + (counts[f] === 1 ? ' piece' : ' pieces') + '</span></button>';
    }).join('');
    var n = cards.length;
    if (!fins.length) { read.textContent = ''; }
    else if (fins.length === 1) { read.innerHTML = '<b>All ' + finLabel(fins[0]) + '</b> &mdash; your saved pieces coordinate beautifully.'; }
    else { read.innerHTML = '<b>' + fins.length + ' finishes</b> across ' + n + ' pieces. Tap a finish to see just those and check they coordinate.'; }
    finCarSync();
  }

  /* ---------- finish carousel state (SHOP BY TYPE recipe - the JS twin of
     the .aw-fin-car CSS; mirrors atelier-collection.js updateCar) ---------- */
  function finCarSync() {
    var car = document.getElementById('awFinCar'), row = document.getElementById('awFinChips');
    var prev = document.getElementById('awFinPrev'), next = document.getElementById('awFinNext');
    var bar = document.getElementById('awFinBar'), th = document.getElementById('awFinBarTh');
    if (!car || !row) return;
    var atStart = row.scrollLeft <= 2;
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    car.classList.toggle('aw-at-start', atStart);
    car.classList.toggle('aw-at-end', atEnd);
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    if (bar && th) {
      var maxScroll = row.scrollWidth - row.clientWidth;
      if (maxScroll > 1) {
        bar.style.display = '';
        var frac = Math.max(row.clientWidth / row.scrollWidth, 0.14);
        var p = row.scrollLeft / maxScroll;
        th.style.width = (frac * 100) + '%';
        th.style.transform = 'translateX(' + (p * (1 / frac - 1) * 100) + '%)';
      } else {
        bar.style.display = 'none';
      }
    }
  }

  function applyFilter() {
    grid.querySelectorAll('.pc').forEach(function (c) {
      c.classList.toggle('dim', !!activeFin && c.dataset.finish !== activeFin);
    });
    document.querySelectorAll('.aw-fin-chip').forEach(function (ch) {
      ch.classList.toggle('on', ch.dataset.fin === activeFin);
    });
    var clr = document.getElementById('awFinClear');
    if (clr) clr.classList.toggle('show', !!activeFin);
  }

  /* ---------- project stack (thumbnails of what's saved) ---------- */
  function buildProjStack() {
    var stack = document.getElementById('awProjStack');
    if (!stack) return;
    var max = 5;
    var html = '';
    grid.querySelectorAll('.pc').forEach(function (c, i) {
      if (i >= max) return;
      var img = c.querySelector('.pc-im img');
      html += '<span class="th">' + (img ? '<img src="' + img.getAttribute('src') + '" alt="">' : '') + '</span>';
    });
    var extra = items.length - max;
    if (extra > 0) html += '<span class="th more">+' + extra + '</span>';
    stack.innerHTML = html;
  }

  /* ---------- sort ---------- */
  function applySort(mode) {
    currentSort = mode;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pc'));
    cards.sort(function (a, b) {
      if (mode === 'price-asc') return cardPrice(a) - cardPrice(b);
      if (mode === 'price-desc') return cardPrice(b) - cardPrice(a);
      var da = +a.dataset.added || 0, db = +b.dataset.added || 0;
      return mode === 'oldest' ? da - db : db - da;
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  /* ---------- remove (through SWishlist, then reconcile) ---------- */
  function removeItem(card, it) {
    card.classList.add('removing');
    var done = function () {
      card.remove();
      items = items.filter(function (x) { return x.handle !== it.handle; });
      if (!items.length) root.dataset.wlState = 'empty';
      setCount(items.length);
      buildFinishSummary(); buildProjStack(); applyFilter();
    };
    Promise.resolve()
      .then(function () { return window.SWishlist.removeFromWishlist(it.handle); })
      .catch(function (e) { console.warn('[atelier-wishlist] remove failed', e); })
      .then(function () {
        if (window.SWishlist.refreshCount) { try { window.SWishlist.refreshCount(); } catch (e) {} }
        setTimeout(done, 340);
      });
  }

  /* ---------- controls ---------- */
  function wire() {
    // finish chips (delegated - chips are rebuilt on each render)
    document.getElementById('awFinChips').addEventListener('click', function (e) {
      var chip = e.target.closest('.aw-fin-chip'); if (!chip) return;
      activeFin = activeFin === chip.dataset.fin ? null : chip.dataset.fin;
      applyFilter();
    });
    document.getElementById('awFinClear').addEventListener('click', function () { activeFin = null; applyFilter(); });
    // finish carousel: arrows step, scroll/resize keep fades + bar honest
    // (the row element is static; only its chip content rebuilds per render)
    var finRow = document.getElementById('awFinChips');
    var finPrev = document.getElementById('awFinPrev'), finNext = document.getElementById('awFinNext');
    function finStep(dir) { finRow.scrollBy({ left: dir * Math.max(finRow.clientWidth * 0.7, 160), behavior: 'smooth' }); }
    if (finPrev) finPrev.addEventListener('click', function () { finStep(-1); });
    if (finNext) finNext.addEventListener('click', function () { finStep(1); });
    if (finRow) finRow.addEventListener('scroll', finCarSync, { passive: true });
    window.addEventListener('resize', finCarSync);

    // sort
    document.getElementById('awSort').addEventListener('change', function (e) { applySort(e.target.value); });

    // view toggle
    document.getElementById('awView').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      root.dataset.view = b.dataset.view;
      document.querySelectorAll('#awView button').forEach(function (x) { x.classList.toggle('on', x === b); });
    });

    // add all to cart (adds one variant per saved item)
    var addAll = document.getElementById('awAddAll');
    if (addAll) addAll.addEventListener('click', function () {
      var ids = items.map(function (i) { return i.variantId; }).filter(Boolean);
      if (!ids.length) { toast('Nothing to add'); return; }
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      }).then(function (r) {
        if (r.ok) { toast('All pieces added to cart'); document.dispatchEvent(new CustomEvent('cart:refresh')); }
        else toast('Some items could not be added');
      }).catch(function () { toast('Could not add to cart'); });
    });

    // share (v1: current page URL + social. NOTE: SWishlist tokenised share link -
    // so a recipient sees the SENDER's list - is a planned fast-follow)
    var shareBtn = document.getElementById('awShareBtn');
    var sharePop = document.getElementById('awSharePop');
    var url = window.location.origin + '/pages/wishlist';
    var urlInput = document.getElementById('awShareUrl');
    if (urlInput) urlInput.value = url;
    var wa = document.getElementById('awShareWa'); if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent('My bathroom wishlist: ' + url);
    var fb = document.getElementById('awShareFb'); if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    var em = document.getElementById('awShareEmail'); if (em) em.href = 'mailto:?subject=' + encodeURIComponent('My bathroom wishlist') + '&body=' + encodeURIComponent(url);
    if (shareBtn && sharePop) {
      shareBtn.addEventListener('click', function (e) { e.stopPropagation(); sharePop.classList.toggle('open'); });
      document.addEventListener('click', function (e) { if (!e.target.closest('.aw-share-wrap')) sharePop.classList.remove('open'); });
      var copyBtn = document.getElementById('awCopyBtn');
      if (copyBtn) copyBtn.addEventListener('click', function () {
        if (navigator.clipboard) navigator.clipboard.writeText(url);
        else { urlInput.select(); document.execCommand('copy'); }
        sharePop.classList.remove('open'); toast('Link copied');
      });
    }

    // re-sync if the wishlist changes elsewhere (PDP heart, another tab, etc.)
    ['st-deleted-product', 'st-added-product', 'st-updated-wishlist'].forEach(function (ev) {
      document.addEventListener(ev, function () { clearTimeout(wire._sync); wire._sync = setTimeout(render, 250); });
    });
  }

  whenReady(function () { wire(); render(); });
})();
